import { render, staticRenderFns } from "./SimCardDeActivateGPRS.vue?vue&type=template&id=9c662804&"
import script from "./SimCardDeActivateGPRS.vue?vue&type=script&lang=js&"
export * from "./SimCardDeActivateGPRS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports